import React, { useContext } from 'react'
import Card from './Card'
import { NavigationContext } from '../context/NavigationContext';
import MenuItem from './MenuItem';

const NavigationMenu = () => {
    const { pages } = useContext(NavigationContext)

    return (
        <div>
            <h3>Menu</h3>
            <Card size="medium">
                {Object.keys(pages).map(item => <MenuItem currentPage={pages[item]} key={pages[item].uri} />)}
            </Card>
        </div>
    );
}

export default NavigationMenu;